import React from 'react';
import './PageStyles.css';

const InvestorRelations = () => {
    return (
        <div className="page-container">
            <section className="page-hero">
                <div className="page-hero-content">
                    <h1 className="page-hero-title">Investor Relations</h1>
                    <p className="page-hero-subtitle">
                        Information for investors and stakeholders.
                    </p>
                </div>
            </section>
            <section className="value-props-section">
                <div className="value-props-container">
                    <p>Content coming soon...</p>
                </div>
            </section>
        </div>
    );
};

export default InvestorRelations;

